import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from 'react-select';

class SetupHidePatterns extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        companies: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            hidePatterns: props.baseData.userData ? this.props.baseData.companies.currentCompany.hide_patterns : false,
        };

        this.translate = this.props.baseData.translate;

        this.saveSettings = this.saveSettings.bind(this);
        this.updateCompanies = this.updateCompanies.bind(this);
        this.selectOption = this.selectOption.bind(this);

    }

    saveSettings(event) {

        if (!event) return null;
        if (event.value !== true && event.value !== false) return null;

        const params = {
            action: 'saveHidePatterns',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            //userId: this.props.baseData.userData.id,
            hidePatterns: event.value
        };

        const callback = function (res) {
            if (res.success) {
                this.setState({
                    hidePatterns: event.value
                }, this.updateCompanies);
            } else {
                alert(this.translate(res.msgKey));
            }
        }.bind(this);

        this.api.request('SaveCompanySettings', params, callback, null);

    }

    updateCompanies() {

        this.props.companies.setHidePatternSetting(this.props.baseData.companies.currentCompany.id, this.state.hidePatterns);

    }

    selectOption(event) {

        if (!event) return null;
        if (event.value !== true && event.value !== false) return null;

        this.setState({
            hidePatterns: event.value
        });

    }

    getOptions() {

        return [
            {
                label: this.translate('yes'),
                value: false
            },
            {
                label: this.translate('no'),
                value: true
            }
        ];

    }

    render() {

        const options = this.getOptions();

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('patterns')}</h1>
                </nav>

                <div>
                    <p>{this.translate('setupText4')}</p>
                </div>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('showPatterns')}</td>

                                <td className="text-left">
                                    <Select
                                        name="form-field-name"
                                        className="chosen-container chosen-container-single"
                                        style={{width: '260px'}}
                                        options={options}
                                        onChange={this.saveSettings}
                                        value={options.find(o => o.value === this.state.hidePatterns) || null}
                                        placeholder={this.translate('select') + '...'}
                                        clearable={false}
                                        noResultsText={this.translate('noResultsFound')}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default SetupHidePatterns;